import {
	Breakpoints,
	Container,
	ContainerGutter,
	CTA,
	Layout,
	Text,
	TextAlignment,
	TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import { ChevronRight, NewCarPrivate } from '@volkswagen-onehub/icons-core';
import { LayerHandleV2 } from '@volkswagen-onehub/layer-manager';
import * as React from 'react';
import styled from 'styled-components';
import { DataVehicles, ErrorType, VehicleStatus } from '@esportal/portal-service';
import { AlertVehicleManagerLayer } from './layer/alertVehicleManagerLayer';
import { VehicleManagerLayer } from './layer/vehicleManagerLayer';
import { CarAlertIcon } from './utils/car-alert-icon';
import { useTrackingManager } from '../../tracking/useTrackingManager';
import { formatOwnership } from '../../tracking/trackingHelper';
import { COLOR_TOKEN } from '../../helpers/color-tokens';

const VehicleToConfirmLayout = styled.div`
	position: fixed;
	bottom: 20px;
	width: 100%;
	z-index: 99;
`;

const VehicleToConfirmContainer = styled.div`
	background: white;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
	border-radius: 10px;
	padding: 16px;
	gap: 3px;

	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const MyVehicles = styled.div<{ notificationBarHeight: number }>`
	position: absolute;
	top: calc(var(--size-dynamic0130) + ${(props: { notificationBarHeight: number }) => props.notificationBarHeight}px);
	right: 0;
	width: fit-content;

	background: white;
	z-index: 1;
	display: inline-flex;
	align-items: center;
	border-radius: 8px 0 0 8px;
`;

const Blue600Container = styled(Text)`
	color: ${COLOR_TOKEN.button.primary};
`;

const IconStyled = styled.div`
	& svg {
		width: 24px;
		height: 24px;
	}
`;

const StyledContainer = styled.div`
	padding: 8px 18px 8px 12px;
`;

export const VehicleManager = ({
	userVehicles,
	isJourneyLayerVisible,
	setIsJourneyLayerVisible,
	setErrorType,
	errorType,
	notificationBarHeight,
}: {
	userVehicles: DataVehicles | null;
	isJourneyLayerVisible: boolean;
	setIsJourneyLayerVisible: React.Dispatch<React.SetStateAction<boolean>>;
	headerRef: React.RefObject<HTMLElement>;
	setErrorType: React.Dispatch<React.SetStateAction<ErrorType>>;
	errorType: ErrorType;
	notificationBarHeight: number;
}): React.ReactElement => {
	const trackingManager = useTrackingManager();

	const layerRef = React.useRef<LayerHandleV2<any>>(null);
	const alertLayerRef = React.useRef<LayerHandleV2<any>>(null);

	const [vehicles, setVehicles] = React.useState<DataVehicles | null>(userVehicles);
	const [isAlertLayerVisible, setIsAlertLayerVisible] = React.useState<boolean>(false);
	// const [isCTAVisible, setIsCTAVisible] = React.useState(true);
	// const [isHeaderVisible, setHeaderVisible] = React.useState(true);

	React.useEffect(() => {
		if (vehicles != userVehicles) {
			setVehicles(userVehicles);
		}
	}, [userVehicles]);

	React.useEffect(() => {
		if (
			vehicles?.vehicles.length === 0 ||
			vehicles?.vehicles.some((vehicle) => vehicle.status === VehicleStatus.TO_BE_CONFIRMED)
		) {
			setIsJourneyLayerVisible(true);
		}
	}, [vehicles]);

	// React.useEffect(() => {
	// 	const handleScroll = () => {
	// 		if (headerRef.current) {
	// 			const rect = headerRef.current.getBoundingClientRect();
	// 			setHeaderVisible(rect.bottom > 180);
	// 		}

	// React.useEffect(() => {
	// 	const handleScroll = () => {
	// 		if (headerRef.current) {
	// 			const rect = headerRef.current.getBoundingClientRect();
	// 			setHeaderVisible(rect.bottom > 180);
	// 		}

	// 		if (window.scrollY === 0) {
	// 			setIsCTAVisible(true);
	// 		} else {
	// 			setIsCTAVisible(false);
	// 		}
	// 	};

	// 	window.addEventListener('scroll', handleScroll);
	// 	return () => {
	// 		window.removeEventListener('scroll', handleScroll);
	// 	};
	// }, [headerRef]);

	const handleJourneyLayerVisibility = () => {
		trackingManager.trackClubVWButtonClick(
			'Mis coches',
			{ contentId: 'Open Data User cars layer' },
			{ vehicle: formatOwnership(vehicles?.vehicles) },
		);
		setIsJourneyLayerVisible(true);
	};

	return (
		<>
			{/* {!isJourneyLayerVisible && isHeaderVisible && vehicles && vehicles?.vehicles.length > 0 && ( */}
			{!isJourneyLayerVisible && vehicles && vehicles?.vehicles.length > 0 && (
				<MyVehicles
					onClick={handleJourneyLayerVisibility}
					style={{ cursor: 'pointer' }}
					notificationBarHeight={notificationBarHeight}
				>
					<StyledContainer>
						<Container wrap={'never'} gutter={ContainerGutter.static150} verticalAlign={'center'}>
							<IconStyled>
								<NewCarPrivate variant="default" aria-hidden />
							</IconStyled>

							{/* {isCTAVisible && ( */}
							<Container wrap={'never'} gutter={ContainerGutter.static150} verticalAlign={'center'}>
								<Blue600Container appearance={TokenTextAppearance.headline100} textAlign={TextAlignment.center} bold>
									Mis coches
								</Blue600Container>

								<CTA
									tag="button"
									emphasis="nbab"
									onClick={() => undefined}
									aria-label="Mis coches"
									size="small"
									icon={<ChevronRight variant="small" aria-hidden />}
								/>
							</Container>
							{/* )} */}
						</Container>
					</StyledContainer>
				</MyVehicles>
			)}

			<VehicleManagerLayer
				className="content-layer"
				vehicles={vehicles}
				setIsJourneyLayerVisible={setIsJourneyLayerVisible}
				isJourneyLayerVisible={isJourneyLayerVisible}
				setIsAlertLayerVisible={setIsAlertLayerVisible}
				layerRef={layerRef}
				alertLayerRef={alertLayerRef}
				setErrorType={setErrorType}
			/>

			<AlertVehicleManagerLayer
				setIsAlertLayerVisible={setIsAlertLayerVisible}
				isAlertLayerVisible={isAlertLayerVisible}
				setIsJourneyLayerVisible={setIsJourneyLayerVisible}
				alertLayerRef={alertLayerRef}
				errorType={errorType}
			/>

			{vehicles?.vehicles.some((vehicle) => vehicle.status === VehicleStatus.TO_BE_CONFIRMED) &&
				!isJourneyLayerVisible && (
					<VehicleToConfirmLayout>
						<Layout
							data-testid="vehicle-manager-layout"
							appearance={{
								[Breakpoints.default]: [
									{ name: '.', columns: 1 },
									{ name: 'a', columns: 22 },
									{ name: '.', columns: 1 },
								],
								[Breakpoints.b560]: [
									{ name: '.', columns: 4 },
									{ name: 'a', columns: 16 },
									{ name: '.', columns: 4 },
								],
								[Breakpoints.b960]: [
									{ name: '.', columns: 5 },
									{ name: 'a', columns: 14 },
									{ name: '.', columns: 5 },
								],
								[Breakpoints.b1280]: [
									{ name: '.', columns: 7 },
									{ name: 'a', columns: 10 },
									{ name: '.', columns: 7 },
								],
								[Breakpoints.b1600]: [
									{ name: '.', columns: 8 },
									{ name: 'a', columns: 8 },
									{ name: '.', columns: 8 },
								],
								[Breakpoints.b2560]: [
									{ name: '.', columns: 9 },
									{ name: 'a', columns: 6 },
									{ name: '.', columns: 9 },
								],
							}}
							allowOverflowingContent
						>
							<VehicleToConfirmContainer className="vehicle-to-confirm-container">
								<Container wrap={'never'} verticalAlign={'center'} gutter={ContainerGutter.static200} shrinkContent>
									<IconStyled>
										<CarAlertIcon />
									</IconStyled>

									<Text appearance={TokenTextAppearance.label150} textAlign={TextAlignment.left}>
										Confirma, elimina o añade tu coche para dejar listo tu garaje.
									</Text>
								</Container>

								<CTA
									tag="button"
									emphasis="nbab"
									onClick={() => {
										setIsJourneyLayerVisible(true);
									}}
									aria-label="Confirma, elimina o añade tu coche para dejar listo tu garaje."
									icon={<ChevronRight variant="default" aria-hidden />}
								/>
							</VehicleToConfirmContainer>
						</Layout>
					</VehicleToConfirmLayout>
				)}
		</>
	);
};
